import { ReactNode } from 'react'
import { Kbd } from '~m/designSystem/components/Kbd/Kbd'
import styles from './CommandPaletteInstructions.module.css'

interface CommandPaletteInstructionsProps {
  status?: ReactNode
}

export function CommandPaletteInstructions({
  status,
}: CommandPaletteInstructionsProps) {
  return (
    <div className={styles.CommandPaletteInstructions}>
      {status && (
        <span className={styles.CommandPaletteInstructions__status}>
          {status}
        </span>
      )}
      <div className={styles.CommandPaletteInstructions__hints} aria-hidden="true">
        <span className={styles.CommandPaletteInstructions__hint}>
          <Kbd>&#x2191;</Kbd>
          <Kbd>&#x2193;</Kbd>
          navigate
        </span>
        <span className={styles.CommandPaletteInstructions__hint}>
          <Kbd>&#x21B5;</Kbd>
          open
        </span>
        <span className={styles.CommandPaletteInstructions__hint}>
          <Kbd>esc</Kbd>
          close
        </span>
      </div>
    </div>
  )
}
